import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';
import ShareButton from '@/components/shared/buttons/ShareButton';

export default function ShareSection({ urlLink, title, rootClass = '' }) {
  const t = useTranslations('catalog');
  
  return (
      <div className={`ltn__social-media ${rootClass}`}>
        <ul>
          <li>{t('share')}:</li>
          <li>
            <Link
                href={`https://api.whatsapp.com/send?text=${title}\n${urlLink}`}
                title="WhatsApp"
                data-app="share_buttons"
                data-app-config='{"service":"whatsapp"}'
                target="_blank"
                rel="nofollow noopener"
            >
              <i className="fab fa-whatsapp"></i>
            </Link>
          </li>
          <li>
            <Link
                href={`https://t.me/share/url?url=${urlLink}&text=${title}`}
                title="Telegram"
                data-app="share_buttons"
                data-app-config='{"service":"telegram"}'
                target="_blank"
                rel="nofollow noopener"
            >
              <i className="fas fa-paper-plane"></i>
            </Link>
          </li>
          <li>
            <Link
                href={`https://www.facebook.com/sharer/sharer.php?u=${urlLink}&title=${title}`}
                title="Facebook"
                data-app="share_buttons"
                data-app-config='{"service":"facebook"}'
                target="_blank"
                rel="nofollow noopener"
            >
              <i className="fab fa-facebook"></i>
            </Link>
          </li>
          <li>
            <Link
                href={`https://www.threads.net/intent/post?text=${urlLink}`}
                title="Threads"
                data-app="share_buttons"
                data-app-config='{"service":"threads"}'
                target="_blank"
                rel="nofollow noopener"
            >
              <i className="fab fa-threads"></i>
            </Link>
          </li>
          <ShareButton productLink={urlLink}/>
        </ul>
      </div>
  );
};
